<form [formGroup]="form" [ngClass]="{'mat-radio-button-check-mark': useCheckMarkStyle}">
  @if (labelName) {
    <div class="ms-2 pt-1">
        <span>{{ labelName }}</span>
    </div>
  }
  @if (displayInline) {
    <mat-radio-group aria-label="Select an option" [formControlName]="nameForControl" [ngClass]="{'radio-no-spacing': noSpacing}">
      @for (item of list; track item) {
        <mat-radio-button [value]="item.value" (change)="onChange($event)">
          @if (!autoTranslate) {
            <span>{{item.text}}</span>
          }
          @if (autoTranslate) {
            <mwp-text-translate [text]="item.text" [jsonKey]="item.text" />
          }
        </mat-radio-button>
      }
    </mat-radio-group>
  }
  @if (!displayInline) {
    <mat-radio-group aria-label="Select an option" [formControlName]="nameForControl" [ngClass]="{'radio-no-spacing': noSpacing}">
      @for (item of list; track item) {
        <div>
          <mat-radio-button [value]="item.value" (change)="onChange($event)">
            @if (!autoTranslate) {
              <span>{{item.text}}</span>
            }
            @if (autoTranslate) {
              <mwp-text-translate [text]="item.text" [jsonKey]="item.text" />
            }
          </mat-radio-button>
        </div>
      }
    </mat-radio-group>
  }
</form>